export const AUTHORIZATION_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pendiente de autorización',
  REJECTED: 'Rechazado',
  QUEUED: 'Procesando',
  ACCEPTED: 'Autorizado con discrepancias',
  ACCEPTED_NO_DISCREPANCIES: 'Autorizado sin discrepancias',
  FAILED_AFTER_QUEUE: 'Fallido',
  CANCELLED: 'Cancelado',
};

export const AUTHORIZATION_STATUS_CHIP_CLASSES: Record<string, string> = {
  PENDING: 'bg-blue-100/70 text-blue-800 border border-blue-200/60',
  REJECTED: 'bg-red-100/70 text-red-800 border border-red-200/60',
  QUEUED: 'bg-gray-100/70 text-gray-800 border border-gray-200/60',
  ACCEPTED: 'bg-amber-100/70 text-amber-800 border border-amber-200/60',
  ACCEPTED_NO_DISCREPANCIES: 'bg-emerald-100/70 text-emerald-800 border border-emerald-200/60',
  FAILED_AFTER_QUEUE: 'bg-red-100/70 text-red-800 border border-red-200/60',
  CANCELLED: 'bg-red-100/70 text-red-800 border border-red-200/60',
};

export const AUTHORIZATION_STATUS_DOT_CLASSES: Record<string, string> = {
  PENDING: 'bg-blue-500',
  REJECTED: 'bg-red-500',
  QUEUED: 'bg-gray-400',
  ACCEPTED: 'bg-amber-500',
  ACCEPTED_NO_DISCREPANCIES: 'bg-emerald-600',
  FAILED_AFTER_QUEUE: 'bg-red-500',
  CANCELLED: 'bg-red-500',
};

export const DEFAULT_STATUS_CHIP_CLASS = 'bg-gray-100/70 text-gray-800 border border-gray-200/60';
export const DEFAULT_STATUS_DOT_CLASS = 'bg-gray-400';
